import axios from 'axios';
import { PostProcessScenario } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-post-process.type';
import { PostProcessRequestInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-post-process-input.type';
import { buildSummaries, buildFishGroupSummaries } from 'views/bluviu-nutrition/features/scenarios-v2/utils/build-summary-from-computations';

/**
 * Calls the post-process endpoint with the given request body.
 * POST /ewosapi/v1/scenarios/gt2-multi/{scenarioId}/post-process
 */
export const getScenarioPostProcess = async (scenarioId: string, data: PostProcessRequestInput | null): Promise<PostProcessScenario> => {
  const res = await axios.post<PostProcessScenario>(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/post-process`, data);
  const resData = res.data;

  return {
    ...resData,
    siteSummary: buildSummaries(resData.siteSummary ?? []),
    fishGroupSummaries: buildFishGroupSummaries(resData.fishGroupSummaries ?? []),
  };
};
